<script>
import { ref, onMounted } from 'vue'
export default {
  name: 'renderless-new-flavor',
  setup (props, { slots }) {
    const component = ref(null)
    const flipped = ref(false)
    const handleObserver = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          flipped.value = true
          observer.unobserve(component.value)
        }
      })
    }
    const observer = new IntersectionObserver(handleObserver)
    onMounted(() => {
      setTimeout(() => {
        observer.observe(component.value)
      }, 2000)
      component.value.onclick = () => (flipped.value = !flipped.value)
    })
    return () => slots.default({
      component,
      flipped: flipped.value
    })
  }
}
</script>
